
import Page from "Vue/components/searchContentTypes/Page.vue";
import News from "Vue/components/searchContentTypes/News.vue";
import Literature from "Vue/components/searchContentTypes/Literature.vue";

export default {
	name: "PagesSearchCard",
	components: {
		'page': Page,
		'newsarticle': News,
		'literature': Literature,
	},
	props: {
		url: {
			type: String,
			default: ""
		},
		contentType: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		},
		kicker: {
			type: String,
			default: ""
		}
	}
};
